export const digestKeys = {
  all: ['digest'] as const,
  current: () => [...digestKeys.all, 'current'] as const,
  /**
   * D51f Phase 2 — `GET /dashboard/issues/{id}/`. A distinct key from
   * `current()`, never an alias: a downgraded member's cached current
   * issue must never satisfy a `detail(id)` read for that same issue id,
   * and vice versa — each has its own cache entry, freshness rules, and
   * error handling (`useDigestQueries.ts`). `id` is a number: the route
   * parses it to a positive integer, and callers holding a string key (e.g. a
   * `priorIssues` record key) must `Number()` it — a string id would create a
   * second, never-matching cache entry for the same issue.
   */
  detail: (id: number) => [...digestKeys.details(), id] as const,
  /**
   * Prefix for every `detail(id)` entry — the target for bulk operations on
   * cached past issues (e.g. `removeQueries` when a relationship change
   * makes them unsafe to flash).
   */
  details: () => [...digestKeys.all, 'detail'] as const,
  /** D51f Phase 2 — `GET /dashboard/issues/`, the paginated archive list. */
  archive: () => [...digestKeys.all, 'archive'] as const,
} as const;
